import { useExpertFilters } from '../../../hooks/expertListHooks/useExpertFilters'; 
import { useExpertList } from '../../../hooks/expertListHooks/useExpertList';    
import { ExpertWrapper } from '../ExpertWrapper'; 
import { BaseExperts } from '../BaseExperts'; 
import { SupremeExperts } from '../SupremeExperts';
import { FeaturedExperts } from '../FeaturedExperts';

const Doctor = () => {
  // Lock this page to 'Doctor'
  const { 
    searchTerm, 
    setSearchTerm, 
    sortBy, 
    setSortBy, 
    sortOrder, 
    setSortOrder, 
    minRating, 
    setMinRating, 
    filters 
  } = useExpertFilters('Doctor');
  
  const { baseExperts, supremeExperts, featuredExperts, loading, error } = useExpertList(filters);

  return (
    <ExpertWrapper
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      activeCategory="Doctor"
      loading={loading}
      error={error}
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
      minRating={minRating}
      setMinRating={setMinRating}
    >
      <BaseExperts 
        experts={baseExperts} 
        title="All Doctors" 
        loading={loading} 
        error={!!error} 
      />
      <SupremeExperts 
        experts={supremeExperts} 
        title="Supreme Doctors" 
        loading={loading} 
        error={!!error} 
      />
      <FeaturedExperts 
        experts={featuredExperts} 
        title="Featured Doctors" 
        loading={loading} 
        error={!!error} 
      />
    </ExpertWrapper>
  );
};

export default Doctor;